import { Modal } from 'react-bootstrap'
import React, { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'
import store from '../../../../redux/store'
import { ITransport } from '../../../../types/IDeclaration'

interface SanctionModalProps {
  isSanctionModalVisible: boolean;
  setSanctionModalVisible: Dispatch<SetStateAction<boolean>>;
  setProfileModalVisible: Dispatch<SetStateAction<boolean>>
  setIsBlacklistWarningModalVisible: Dispatch<SetStateAction<boolean>>
  sanctionedCodes: Array<string>;
  isBlacklistNotEmpty: (transport: ITransport) => boolean;
}

function SanctionModal(props: SanctionModalProps) {
  const { t } = useTranslation()
  const {
    isSanctionModalVisible, setSanctionModalVisible, sanctionedCodes,
    isBlacklistNotEmpty, setProfileModalVisible, setIsBlacklistWarningModalVisible,
  } = props

  const state = store.getState()
  return (
    <Modal
      show={isSanctionModalVisible}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      onHide={() => setSanctionModalVisible(false)}
      animation={false}
      centered
    >
      <Modal.Header>
        <Modal.Title>
          <h2 className="text-uppercase">{t('declaration.sanctionedCode')}</h2>
          <button
            type="button"
            className="btn btn-link no-underline btn-lg d-flex justify-content-center align-items-center px-0"
            onClick={() => setSanctionModalVisible(false)}
          >
            <span>{t('buttons.close')}</span>
            <i className="fal fa-times fa-2x ms-2" />
          </button>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="m-4">
          <h4 className="mb-3 text-black">{t('declaration.sanctionWarning')}</h4>
          {sanctionedCodes.map((item) => (
            <li>{item}</li>
          ))}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-dark btn-lg m-0 text-primary"
          onClick={() => {
            setSanctionModalVisible(false)
            if (isBlacklistNotEmpty(state.transportReducer.transport!)) {
              setIsBlacklistWarningModalVisible(true)
              return
            }
            setProfileModalVisible(true)
          }}
        >
          <i className="fal fa-reply fa-flip-horizontal me-2" />
          <span>{t('buttons.send')}</span>
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default SanctionModal
